import common from '../common';

export default {
  jpath: ['image'],
  find: common.basenameFind,
  getProperty: common.getTargetProperty,
};
